import { useTranslation } from 'react-i18next';
import {
  ContractorCompanyRate,
  UpdateContractorCompanyRate,
} from 'api/services/company/company-service.schema';
import { getRateCents } from './contractor-rate-values';

const useContractorRateColumns = () => {
  const { t } = useTranslation('ogp-screen-specific');
  const jobTypeLabel = t('company.contractor-rates.job-type.label', { defaultValue: 'Functie' });
  const rateUnitLabel = t('company.contractor-rates.unit.label', { defaultValue: '€/uur' });
  const columns: {
    employmentType: UpdateContractorCompanyRate['employmentType'];
    label: string;
    rateCents: (jobType: ContractorCompanyRate) => number | null;
  }[] = [
    {
      employmentType: 'FREELANCER',
      label: t('company.contractor-rates.freelancer.label', { defaultValue: 'Zelfstandige' }),
      rateCents: (jobType) => getRateCents(jobType, 'FREELANCER'),
    },
    {
      employmentType: 'TEMPWORKER',
      label: t('company.contractor-rates.temp-worker.label', { defaultValue: 'Uitzendkracht' }),
      rateCents: (jobType) => getRateCents(jobType, 'TEMPWORKER'),
    },
    {
      employmentType: 'EMPLOYEE',
      label: t('company.contractor-rates.employee.label', { defaultValue: 'Werknemer' }),
      rateCents: (jobType) => getRateCents(jobType, 'EMPLOYEE'),
    },
  ];

  return { columns, jobTypeLabel, rateUnitLabel };
};

export { useContractorRateColumns };
